__turbopack_context__.v({
  "endpointLink": "_8E0hSG_endpointLink",
  "heading": "_8E0hSG_heading",
  "headingWithIcon": "_8E0hSG_headingWithIcon",
  "offsetAnchor": "_8E0hSG_offsetAnchor",
  "stickyHeading": "_8E0hSG_stickyHeading",
});
